import React, { useContext, useRef, useState, useEffect } from "react";
import {
  MdOutlineArrowBackIos,
  MdOutlineArrowForwardIos,
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Language } from "../../../App";
import CourseCard from "../cards/CourseCard";
import NewCourseCardShimmer from "../shimmers/NewCourseCardShimmer";
import { SEE_ALL_TRENDING_PAGE } from "../../../constants/RoutesUrl";
import MixpanelManager from "../../../constants/MixpanelManager";
import { MixpanelEvents } from "../../../constants/MixpanelEvents";

function TrendingCourses({ courses, loading }) {
  const { lang } = useContext(Language);
  const navigate = useNavigate();
  const scrollRef = useRef(null);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(true);

  const checkScroll = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      setCanScrollLeft(scrollLeft > 10);
      setCanScrollRight(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  useEffect(() => {
    checkScroll();
    window.addEventListener("resize", checkScroll);
    return () => window.removeEventListener("resize", checkScroll);
  }, [courses]);

  const handleScroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = scrollRef.current.clientWidth * 0.75;
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
      setTimeout(checkScroll, 350);
    }
  };

  const handleSeeAllClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    MixpanelManager.track(MixpanelEvents.trendingCourses, { action: "see_all" });
    navigate(SEE_ALL_TRENDING_PAGE);
  };

  return (
    <>
      <div className="cr-section-header">
        <div className="cr-section-title-wrap">
          <h3 className="cr-section-title">
            {lang.trending_new_courses || "Trending & New Courses"}
          </h3>
          <p className="cr-section-subtitle">
            Most popular and recently published clinical masterclasses
          </p>
        </div>
        <button className="cr-see-all-btn" onClick={handleSeeAllClick}>
          <span>{lang.see_all_text || "See All"}</span>
          <MdOutlineArrowForwardIos size={14} />
        </button>
      </div>

      <div className="cr-scroll-wrapper position-relative">
        {canScrollLeft && (
          <button
            className="cr-scroll-btn cr-scroll-btn-left"
            onClick={() => handleScroll("left")}
            aria-label="Scroll Left"
          >
            <MdOutlineArrowBackIos size={15} />
          </button>
        )}

        {canScrollRight && (
          <button
            className="cr-scroll-btn cr-scroll-btn-right"
            onClick={() => handleScroll("right")}
            aria-label="Scroll Right"
          >
            <MdOutlineArrowForwardIos size={15} />
          </button>
        )}

        <div
          className="cr-horizontal-scroll"
          ref={scrollRef}
          onScroll={checkScroll}
        >
          {loading ? (
            Array.from({ length: 3 }).map((_, index) => (
              <div key={index} className="cr-scroll-item cr-scroll-item-trending">
                <NewCourseCardShimmer width="100%" />
              </div>
            ))
          ) : courses?.length > 0 ? (
            courses.map((course) => (
              <div key={course.id} className="cr-scroll-item cr-scroll-item-trending">
                <CourseCard course={course} width="100%" />
              </div>
            ))
          ) : null}
        </div>
      </div>
    </>
  );
}

export default React.memo(TrendingCourses);